import { Point } from 'geojson';
import { BaseService } from '../../service/base';
import { DeviceTelemetryDTO } from '../../service/telemetry';

export interface SpotRockingAssetData {
    id: string;
    assetId: string;
    timestamp: number;
    position: Point;
    heading: number;
    totalRock: number;
    regionId: string;
    telemetry: google.maps.LatLng[];
}

export interface SpotRockingRegionDTO {
    id: string;
    name: string;
    geometry: google.maps.LatLng[];
}

export class SpotRockingService extends BaseService {
    private regionCache?: SpotRockingRegionDTO[];

    init(): Promise<void> {
        return new Promise((resolve) => {
            // Initialization logic here if needed
            resolve();
        });
    }

    async saveRegion(data: SpotRockingRegionDTO) {
        if (data.id == undefined || data.id == '') {
            const response = await this.post<SpotRockingRegionDTO>(this.url + '/api/' + this.orgid + '/spotrocking/region', data);
            return response;
        } else {
            const response = await this.put<SpotRockingRegionDTO>(this.url + '/api/' + this.orgid + '/spotrocking/region', data);
            return response;
        }
    }

    async deleteRegion(id: string) {
        const response = await this.delete<SpotRockingRegionDTO>(this.url + '/api/' + this.orgid + '/spotrocking/region/', id);
        return response;
    }

    async fetchRegions(): Promise<SpotRockingRegionDTO[]> {
        if (this.regionCache != undefined) {
            return this.regionCache;
        }

        const response = await this.get<SpotRockingRegionDTO[]>(this.url + '/api/' + this.orgid + '/spotrocking/region');
        if (response.ok && response.parsedBody) {
            this.regionCache = response.parsedBody;
            return this.regionCache;
        } else {
            return [];
        }
    }

    public refreshRegions(): void {
        this.regionCache = undefined;
    }

    async fetchSpotRockingData(start: number, end: number) {
        const response = await this.get<SpotRockingAssetData[]>(this.url + '/api/' + this.orgid + '/spotrocking/data?start=' + start + '&end=' + end);
        if (response.ok && response.parsedBody) {
            return response.parsedBody;
        }
    }

    public getRegionById(id: string): SpotRockingRegionDTO | undefined {
        return this.regionCache?.find((r) => r.id === id);
    }
}
